var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',[_c('tbody',[_c('tr',[_c('td',[_vm._v("Week starts on")]),_c('th',[_vm._v(_vm._s(_vm._f("day")(_vm.startDay)))])]),_c('tr',[_c('td',[_vm._v("Day starts/ends at")]),_c('th',[_vm._v(_vm._s(_vm._f("minutesToTime")((_vm.startHour * 60))))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }